import types from 'actions/types'
import {combineReducers} from 'redux'
import skills from './skills'
import * as signUpFinal from 'actions/signUpFinal'

export const skillDrawerOpen = (state = false, action) => {
  switch (action.type) {
    case types.ONBOARDING_ALL_SKILLS_SHOW: return true
    case types.ONBOARDING_ALL_SKILLS_HIDE: return false
    case types.ONBOARDING_SKILL_SHOW: return false
    default: return state
  }
}

export const skillHintOpen = (state = false, action) => {
  switch (action.type) {
    case signUpFinal.types.FINALISE_SUCCESS: return true
    case types.ONBOARDING_SKILL_HINT_DISMISS: return false
    default: return state
  }
}

export const skillHintDismissed = (state = false, action) => {
  switch (action.type) {
    case types.ONBOARDING_SKILL_HINT_DISMISS: return true
    default: return state
  }
}

export default combineReducers({
  skillDrawerOpen,
  skillHintOpen,
  skillHintDismissed,
  skills,
})
